import React from 'react';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './BanButton.module.css';
import { CommonButton } from '_components';


export class BanButton extends React.Component {
    render() {
        let cls;
        cls = styles.button;

        if (this.props.className ) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title} onClick={this.props.onClick} size={this.props.size} className={cls} >
                <FontAwesomeIcon icon={faBan} transform="shrink-6" color="white" />
            </CommonButton>
        );
    }
}
